module.exports = __webpack_public_path__ + "img/configuration_icon_on.699ef7fc.svg";